import { useTranslation } from "react-i18next";

import View from "components/elements/View";
import { Col, Row, Button, notification } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { useState } from "react";
import { downloadFile } from "helpers/downloadFile";
import getAuthority from "utils/getAuthority";
import { Roles } from "types/user.types";

function Reporting(): JSX.Element {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const roles = getAuthority();
  const isAdmin =
    roles.length >= 1 &&
    (roles.includes(Roles.LinkPL) || roles.includes(Roles.LinkAdmin));

  const downloadGesamtReport = () => {
    setIsLoading(true);
    downloadFile(
      "Report/GesamtReport",
      t("reporting.download.gesamtreport_filename")
    )
      .then(async () => {
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        notification.error({ message: err.message });
      });
  };

  const downloadEinzelfallReport = () => {
    setIsLoading(true);
    downloadFile(
      "Report/EinzelfallReport",
      t("reporting.download.einzelfallreport_filename")
    )
      .then(async () => {
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        notification.error({ message: err.message });
      });
  };

  const downloadDetailReport = () => {
    setIsLoading(true);
    downloadFile(
      "Report/DetailReport",
      t("reporting.download.detailreport_filename")
    )
      .then(async () => {
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        notification.error({ message: err.message });
      });
  };

  const downloadTreuhandstelleReport = () => {
    setIsLoading(true);
    downloadFile(
      "Report/ThsDetailReport",
      t("reporting.download.treuhandstellereport_filename")
    )
      .then(async () => {
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        notification.error({ message: err.message });
      });
  };

  const downloadEntschaedigungLwReport = () => {
    setIsLoading(true);
    downloadFile(
      "Report/EntschaedigungLwReport",
      t("reporting.download.entschaedigungLwReport_filename")
    )
      .then(async () => {
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        notification.error({ message: err.message });
      });
  };

  const downloadEntschaedigungThReport = () => {
    setIsLoading(true);
    downloadFile(
      "Report/EntschaedigungThReport",
      t("reporting.download.entschaedigungThReport_filename")
    )
      .then(async () => {
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        notification.error({ message: err.message });
      });
  };

  const downloadNightlyDetailReport = () => {
    setIsLoading(true);
    downloadFile(
      "Report/NightlyDetailReport",
      t("reporting.download.detailreport_filename")
    )
      .then(async () => {
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        notification.error({ message: err.message });
      });
  };

  return (
    <View title={t("reporting.title")}>
      <Row gutter={[0, 24]}>
        <Col span={24}>
          <Row justify="center">
            <Col span={7}>
              <Button
                block
                icon={<DownloadOutlined />}
                type="primary"
                onClick={downloadGesamtReport}
                loading={isLoading}
              >
                {t("reporting.download.gesamtreport")}
              </Button>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row justify="center">
            <Col span={7}>
              <Button
                block
                icon={<DownloadOutlined />}
                type="primary"
                onClick={downloadEinzelfallReport}
                loading={isLoading}
              >
                {t("reporting.download.einzelfallreport")}
              </Button>
            </Col>
          </Row>
        </Col>
        {isAdmin && (
          <>
            <Col span={24}>
              <Row justify="center">
                <Col span={7}>
                  <Button
                    block
                    icon={<DownloadOutlined />}
                    type="primary"
                    onClick={downloadNightlyDetailReport}
                    loading={isLoading}
                  >
                    {t("reporting.download.detailreportnightly")}
                  </Button>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row justify="center">
                <Col span={7}>
                  <Button
                    block
                    icon={<DownloadOutlined />}
                    type="primary"
                    onClick={downloadDetailReport}
                    loading={isLoading}
                  >
                    {t("reporting.download.detailreport")}
                  </Button>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row justify="center">
                <Col span={7}>
                  <Button
                    block
                    icon={<DownloadOutlined />}
                    type="primary"
                    onClick={downloadTreuhandstelleReport}
                    loading={isLoading}
                  >
                    {t("reporting.download.treuhandstellereport")}
                  </Button>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row justify="center">
                <Col span={7}>
                  <Button
                    block
                    icon={<DownloadOutlined />}
                    type="primary"
                    onClick={downloadEntschaedigungLwReport}
                    loading={isLoading}
                  >
                    {t("reporting.download.entschaedigungLwReport")}
                  </Button>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row justify="center">
                <Col span={7}>
                  <Button
                    block
                    icon={<DownloadOutlined />}
                    type="primary"
                    onClick={downloadEntschaedigungThReport}
                    loading={isLoading}
                  >
                    {t("reporting.download.entschaedigungThReport")}
                  </Button>
                </Col>
              </Row>
            </Col>
          </>
        )}
      </Row>
    </View>
  );
}

export default Reporting;
